module.exports = __webpack_public_path__ + "media/v2/components/Header/shared/Profile/arrow-95742d6fbc07fb0e913636f740ec6730.svg";